export default "__VITE_ASSET__681976bc__"